module.exports = __webpack_public_path__ + "static/media/img_10.ea7797f0.png";